<template>
	<div class="achievement px-45 py-4 bg-secondary text-white leading-normal rounded">
		<div class="corner-accent bg-secondary-900"></div>
		<i class="corner-icon text-6xl fad fa-award"></i>

		<template v-if="!achievement">
			<div class="text-secondary-100 text-lg font-weight-bold">&nbsp;</div>
			<div class="text-3xl leading-tight font-weight-bold">
				&nbsp;
			</div>
		</template>

		<template v-else>

			<template v-if="achievement.name === 'noneFound'">
				<div class="text-secondary-100 text-lg font-weight-bold">Nice going!</div>
				<div class="text-3xl leading-tight font-weight-bold">
					Keep up your outreach efforts
				</div>
			</template>

			<template v-if="achievement.name === 'newPatientsReferred'">
				<div class="text-secondary-100 text-lg font-weight-bold">Congratulations!</div>
				<div class="text-3xl leading-tight font-weight-bold">
					{{ achievement.count }} new {{ pluralize('patient', achievement.count) }} referred last week!
				</div>
			</template>

			<template v-if="achievement.name === 'completeRoutes'">
				<div class="text-secondary-100 text-lg font-weight-bold">Great job!</div>
				<div class="text-3xl leading-tight font-weight-bold">
					{{ achievement.count }} {{ pluralize('route', achievement.count) }} completed last week.
				</div>
			</template>

			<template v-if="achievement.name === 'completeCampaigns'">
				<div class="text-secondary-100 text-lg font-weight-bold">Great job!</div>
				<div class="text-3xl leading-tight font-weight-bold">
					{{ achievement.count }} {{ pluralize('campaign', achievement.count) }} completed last week.
				</div>
			</template>

			<template v-if="achievement.name === 'checkins'">
				<div class="text-secondary-100 text-lg font-weight-bold">
					<template v-if="achievement.count < 10">
						Keep it up!
					</template>
					<template v-else-if="achievement.count >= 10 && achievement.count < 29">
						Nice work!
					</template>
					<template v-else>
						Wow!!
					</template>
				</div>
				<div class="text-3xl leading-tight font-weight-bold">
					You logged {{ achievement.count }} {{ pluralize('check-in', achievement.count) }} last week!
				</div>
			</template>

			<template v-if="achievement.name === 'firstTimeCheckins'">
				<div class="text-secondary-100 text-lg font-weight-bold">Good work!</div>
				<div class="text-3xl leading-tight font-weight-bold">
					{{ achievement.count }} {{ pluralize('physician', achievement.count) }} had their first check-in.
				</div>
			</template>
		</template>

	</div>
</template>

<script>

	export default {
		data() { 
			return {
				achievement: null,
			}
		},

		methods: {
			pluralize(string, count) {
				if (count > 1) {
					return string + 's';
				}
				else {
					return string;
				}
			} 
		},

		created() {
    		axios.get('/api/utilities/achievement').then(({data}) => {
    			this.achievement = data;
    		});
		}
	}

</script>